angular.module('data-ng-path-item').constant(
  'ItemPresenterEnum',
  Enumeration('ItemPresenterEnum', {
    INTAKE: {},
    CAMPUS: {},
    CHECKBOX: {},
    CHOICE: {},
    GENERIC: {},
    DETAILS: {},
    INFO: {},
    POLL: {},
    INTEREST: {},
    LISTSELECTION: {},
    METARANKING: {},
    PROGRAMS: {},
    PLACEMENTTEST: {},
    TOPIC: {},
    APPOINTMENT: {},
    APPOINTMENT_REQUEST: {},
    APPOINTMENT_INVITATION: {},
    ARTICLE: {},
    RANK: {}
  })
);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/types/item_presenter_enum.js